<template src="./BotonesAgendar.html"></template>
<script>
export default {
  name: "BotonesAgendar",
  methods: {
    openChat() {
      this.$store.dispatch("setFabChat", true);
    }
  }
};
</script>
<style src="./BotonesAgendar.scss" lang="scss"></style>
